import styled from 'styled-components';

export const Container = styled.div`
  ${(props) => props.theme.config.typograph.default};
  color: ${(props) => props.theme.config.colors.text_base} !important;
`;
